import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPatch, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { RoleDetail, UpdateRoleDto } from '@/types/settings';

export const useUpdateRole = createMutationHook<RoleDetail, { roleId: string } & UpdateRoleDto>({
  mutationFn: ({ roleId, ...dto }) =>
    apiPatch<RoleDetail, UpdateRoleDto>(
      operationsClient,
      settingsEndpoints.roleDetail(roleId),
      dto,
    ),
  onSuccess: (_data, { roleId }, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.roles() });
    void queryClient.invalidateQueries({ queryKey: settingsKeys.roleDetail(roleId) });
    toast.success('Role updated');
  },
});
